import { render, staticRenderFns } from "./ContestProfileWidget.vue?vue&type=template&id=4cc1df8f&"
import script from "./ContestProfileWidget.vue?vue&type=script&lang=js&"
export * from "./ContestProfileWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContestProfileWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports